<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-8 mx-auto">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Editar Categoría: {{ category.name || 'Cargando...' }}</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="loading" class="text-center py-5">
                            Cargando datos de la categoría...
                        </div>
                        <form v-else @submit.prevent="submitCategory">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">ID Categoría</label>
                                    <argon-input
                                        v-model="category.id"
                                        type="text"
                                        :disabled="true"
                                        placeholder="ID"
                                    />
                                    <small class="text-muted">El ID no es editable.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre</label>
                                    <argon-input v-model="category.name" type="text" placeholder="Ej: Electrónicos" />
                                    <small v-if="submitted && v$.category.name.$error" class="text-danger">Nombre de la categoría requerido.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Estado</label>
                                    <select class="form-control" v-model="category.state">
                                        <option value="1">Activo</option>
                                        <option value="2">Inactivo</option>
                                    </select>
                                    <small v-if="submitted && v$.category.state.$error" class="text-danger">Estado requerido.</small>
                                </div>
                            </div>
                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Actualizar Categoría
                            </argon-button>
                            <argon-button
                                type="button"
                                class="mt-2"
                                color="success"
                                fullWidth
                                size="lg"
                                @click="$router.push('/settings/categories')"
                            >
                                Cancelar
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';

export default {
    name: "EditCategory", // 🛑 Nombre del componente
    components: { ArgonInput, ArgonButton },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        const categoryId = parseInt(this.$route.params.id);
        const companyId = parseInt(localStorage.getItem('companyId'));

        return {
            loading: true,
            submitted: false,
            categoryId: categoryId,
            category: { // 🛑 Objeto de datos
                id: categoryId,
                name: '',
                state: 1,
                company: companyId || null // Aseguramos el company ID para el payload
            }
        };
    },
    validations() {
        return {
            category: {
                name: { required: helpers.withMessage('El nombre es requerido', required) },
                state: { required: helpers.withMessage('El estado es requerido', required) },
                company: { required: helpers.withMessage('ID de compañía faltante', required) }
            }
        };
    },
    mounted() {
        if (this.categoryId) {
            this.fetchCategoryData();
        } else {
            Swal.fire('Error de Ruta', 'ID de categoría no proporcionado.', 'error');
            this.$router.push('/settings/categories');
        }
    },
    methods: {
        async fetchCategoryData() {
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };

            try {
                // 🛑 Endpoint: GET a products_category/:id
                const response = await axios.get(`${this.$store.state.apiURL}products_category/${this.categoryId}`, config);

                // Mapear los datos recibidos (asegúrate de usar los nombres de columnas de tu BD)
                this.category.name = response.data.name;
                this.category.state = response.data.state;

            } catch (error) {
                console.error("Error al obtener datos de la categoría:", error.response || error);
                Swal.fire('Error', 'No se pudieron cargar los datos de la categoría. Es posible que no exista o no pertenezca a su compañía.', 'error');
                this.$router.push('/settings/categories');
            } finally {
                this.loading = false;
            }
        },
        async submitCategory() {
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) {
                Swal.fire({
                    title: 'Datos inválidos',
                    text: 'Por favor, revisa el nombre y el estado.',
                    icon: 'warning',
                    confirmButtonColor: '#0b9257'
                });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            };

            try {
                // Payload de actualización
                const updatePayload = {
                    name: this.category.name,
                    state: this.category.state,
                    company: this.category.company // Usamos company_id como prevención
                };

                // 🛑 CRÍTICO: Usamos el método PUT al endpoint de categoría (ej: products_category/1)
                await axios.put(`${apiURL}products_category/${this.categoryId}`, updatePayload, config);

                Swal.fire({
                    title: 'Actualizado',
                    text: 'La categoría fue actualizada correctamente.',
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                }).then(() => {
                    this.$router.push('/settings/categories');
                });
            } catch (err) {
                console.error("Error al actualizar categoría:", err.response || err);
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudo actualizar la categoría. Verifique los datos.',
                    icon: 'error',
                    confirmButtonColor: '#0b9257'
                });
            }
        }
    }
};
</script>